import apiClient from './api';

export const getToken = () => {
    return localStorage.getItem('token');
};

export const getCurrentUser = () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
};

export const storeAuthData = (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
};

export const clearAuthData = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

export const login = async (credentials) => {
    try {
        const response = await apiClient.post('/user/login-user', credentials);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Login failed' };
    }
};

export const loginWithEmail = async (credentials) => {
    try {
        const response = await apiClient.post('/user/login-user', {
            userEmail: credentials.userEmail,
            userPassword: credentials.userPassword
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Login failed' };
    }
};

export const verifyLoginOTP = async (verificationData) => {
    try {
        const response = await apiClient.post('/user/verify-login-otp', verificationData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'OTP verification failed' };
    }
};

export const register = async (userData) => {
    try {
        const response = await apiClient.post('/user/create-user', userData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Registration failed' };
    }
};

export const verifyRegistrationOTP = async (verificationData) => {
    try {
        const response = await apiClient.post('/user/verify-login-otp', verificationData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'OTP verification failed' };
    }
};

export const getUserProfile = async (userId) => {
    try {
        const response = await apiClient.get(`/user/user-profile?userId=${userId}`);
        return response.data;
    } catch (error) {
        console.error("API Error fetching user profile:", error);
        throw error.response?.data || { message: 'Failed to fetch user profile' };
    }
};

export const updateUserProfile = async (userData) => {
    try {
        const response = await apiClient.post('/user/update-user', userData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Profile update failed' };
    }
};

export const forgotPassword = async (email) => {
    try {
        const response = await apiClient.post('/user/forgot-password', { email });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to send OTP' };
    }
};

export const verifyPasswordResetOTP = async (email, otpCode) => {
    try {
        const response = await apiClient.post('/user/verify-password-reset-otp', {
            email,
            otpCode
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'OTP verification failed' };
    }
};

export const resetPassword = async (email, newPassword) => {
    try {
        const response = await apiClient.post('/user/reset-password', {
            email,
            newPassword
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Password reset failed' };
    }
};

export const resendLoginOTP = async (credentials) => {
    try {
        const response = await fetch('/api/resend-login-otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials)
        });

        if (!response.ok) {
            throw new Error('Failed to resend OTP');
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message || 'Failed to resend OTP');
    }
};

// Get celeb shoutout pricing
export const getCelebShoutoutPricing = async () => {
    try {
        console.log("🔄 authService: Making GET request to /shoutouts/my-pricing");
        const response = await apiClient.get('/shoutouts/my-pricing');
        console.log("✅ authService: API response received:", response);

        // Return the data directly since the API response structure is {message, data}
        return response.data;
    } catch (error) {
        console.error("❌ authService: API error:", error);
        console.error("🔧 authService: Error details:", error.response);
        throw error.response?.data || { message: 'Failed to fetch shoutout pricing' };
    }
};

// Add celeb shoutouts
export const addCelebShoutouts = async (shoutoutsData) => {
    try {
        const response = await apiClient.post('/celebs/add-celebs-shoutouts', shoutoutsData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to save shoutout pricing' };
    }
};

// Update shoutout pricing
export const updateShoutoutPricing = async (pricingData) => {
    try {
        const response = await apiClient.put('/shoutouts/my-pricing', pricingData);
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'Failed to update shoutout pricing' };
    }
};

export const logout = () => {
    clearAuthData();
};